var exports = {
  "I": "x93eb46d8--ba7d29--select-popup",
};

module.exports = exports;
